import { Doctor, Staff, Room } from '../SchedulerTypes';

export const getDoctorName = (id: string | undefined, doctors: Doctor[]) => {
  const doctor = doctors.find(d => d.id === id);
  return doctor ? doctor.name : 'N/A';
};

export const getStaffName = (id: string | undefined, staff: Staff[]) => {
  const staffMember = staff.find(s => s.id === id);
  return staffMember ? staffMember.name : 'N/A';
};

export const getRoomName = (id: string | undefined, rooms: Room[]) => {
  const room = rooms.find(r => r.id === id);
  return room ? `${room.name} (${room.clinic})` : 'N/A';
};
